module.exports = __webpack_public_path__ + "img/effect_mode1.f1c4f9f1.svg";